import request from './service/index';

export function magazineList_Api(data){
    return request({
        url:'CMS/guihua/magazine_list',
        method:'post',
        data:data
    });
}

export function deleteMagazineList_Api(data){
    return request({
        url:'CMS/guihua/magazine_list',
        method:'delete',
        data:data
    });
}

export function magazineCount_Api(){
    return request({
        url:'CMS/guihua/magazine_count',
        method:'get',
    });
}

export function magazineTopicDetail_Api(id){
    return request({
        url:`CMS/guihua/magazine_classification_detail?magazine_classification_id=${id}`,
        method:'get',
    });
}

export function magazineTopicList_Api(id){
    return request({
        url:`CMS/guihua/magazine_classification_list?magazine_id=${id}`,
        method:'get',
    });
}

export function getMagazineTopicDetail_Api(data){
    return request({
        url:'CMS/guihua/magazine_classification_detail',
        method:'post',
        data:data
    });
}

export function updateMagazineTopicDetail_Api(data){
    return request({
        url:'CMS/guihua/magazine_classification_detail',
        method:'put',
        data:data
    });
}

export function deleteMagazineTopicDetail_Api(data){
    return request({
        url:'CMS/guihua/magazine_classification_detail',
        method:'delete',
        data:data
    });
}

export function magazineDetail_Api(id){
    return request({
        url:`CMS/guihua/magazine_detail?magazine_id=${id}`,
        method:'get',
    });
}

export function getMagazineDetail_Api(data){
    return request({
        url:'CMS/guihua/magazine_detail',
        method:'post',
        data:data
    });
}

export function updateMagazineDetail_Api(data){
    return request({
        url:'CMS/guihua/magazine_detail',
        method:'put',
        data:data
    });
}

export function deleteMagazineDetail_Api(data){
    return request({
        url:'CMS/guihua/magazine_detail',
        method:'delete',
        data:data
    });
}

export function magazineArticleList_Api(data){
    return request({
        url:"CMS/guihua/article_list",
        method:'post',
        data:data
    });
}

export function deleteMagazineArticleList_Api(data){
    return request({
        url:'CMS/guihua/article_list',
        method:'delete',
        data:data
    });
}

export function getArticleDetail_Api(id){
    return request({
        url:`CMS/guihua/article_detail?article_id=${id}`,
        method:'get',
    });
}

export function setArticleDetail_Api(data){
    return request({
        url:'CMS/guihua/article_detail',
        method:'post',
        data:data
    });
}

export function updateArticleDetail_Api(data){
    return request({
        url:'CMS/guihua/article_detail',
        method:'put',
        data:data
    });
}

export function deleteArticleDetail_Api(data){
    return request({
        url:'CMS/guihua/article_detail',
        method:'delete',
        data:data
    });
}

export function getArticleRecommendList_Api(){
    return request({
        url:'CMS/guihua/article_top',
        method:'get',
    });
}

export function articleRecommend_Api(data){
    return request({
        url:'CMS/guihua/article_top',
        method:'post',
        data:data
    });
}

export function scholarList_Api(){
    return request({
        url:'CMS/guihua/scholar_list',
        method:'get',

    });
}

export function deleteScholarList_Api(data){
    return request({
        url:'CMS/guihua/scholar_list',
        method:'delete',
        data:data
    });
}

export function scholarDetail_Api(data){
    return request({
        url:'CMS/guihua/scholar_detail',
        method:'post',
        data:data
    });
}

export function getScholarDetail_Api(id){
    return request({
        url:`CMS/guihua/scholar_detail?scholar_id=${id}`,
        method:'get',
    });
}

export function setScholarDetail_Api(data){
    return request({
        url:"CMS/guihua/scholar_detail",
        method:'post',
        data:data
    });
}

export function updateScholarDetail_Api(data){
    return request({
        url:"CMS/guihua/scholar_detail",
        method:'put',
        data:data
    });
}

export function deleteScholarDetail_Api(data){
    return request({
        url:"CMS/guihua/scholar_detail",
        method:'delete',
        data:data
    });
}

export function MagazineRichText_Api(position){
    return request({
        url:`CMS/guihua/text?position=${position}`,
        method:'get',
    });
}

export function magazineRichText_Api(data){
    return request({
        url:"CMS/guihua/text",
        method:'post',
        data:data
    });
}

export function updateMagazineRichText_Api(data){
    return request({
        url:"CMS/guihua/text",
        method:'put',
        data:data
    });
}

export function addArticleTopics_Api(data){
    return request({
        url:'CMS/guihua/news_classification',
        method:'post',
        data:data
    });
}
export function deleteArticleTopics_Api(data){
    return request({
        url:'CMS/guihua/news_classification',
        method:'delete',
        data:data
    });
}
export function updateArticleTopics_Api(data){
    return request({
        url:'CMS/guihua/news_classification',
        method:'put',
        data:data
    });
}
export function getArticleTopics_Api(){
    return request({
        url:'CMS/guihua/news_classification',
        method:'get',
    });
}

export function getComment_Api(id,content_type){
    return request({
        url:`CMS/guihua/comment?content_id=${id}&content_type=${content_type}`,
        method:'get',
    });
}

export function createComment_Api(data){
    return request({
        url:'CMS/guihua/comment',
        method:'post',
        data:data
    });
}

export function updateComment_Api(data){
    return request({
        url:'CMS/guihua/comment',
        method:'put',
        data:data
    });
}

export function deleteComment_Api(data){
    return request({
        url:'CMS/guihua/comment',
        method:'delete',
        data:data
    });
}

export function getNewsList_Api(data){
    return request({
        url:'CMS/guihua/news_list',
        method:'post',
        data:data
    });
}

export function deleteNewsList_Api(data){
    return request({
        url:'CMS/guihua/news_list',
        method:'delete',
        data:data
    });
}

export function getNewsDetail_Api(id){
    return request({
        url:`CMS/guihua/news_detail?news_id=${id}`,
        method:'get',
    });
}

export function createNewsDetail_Api(data){
    return request({
        url:'CMS/guihua/news_detail',
        method:'post',
        data:data
    });
}

export function updateNewsDetail_Api(data){
    return request({
        url:'CMS/guihua/news_detail',
        method:'put',
        data:data
    });
}

export function deleteNewsDetail_Api(data){
    return request({
        url:'CMS/guihua/news_detail',
        method:'delete',
        data:data
    });
}

export function magazineDropDown_Api(){
    return request({
        url:'CMS/tools/magazine_drop_down',
        method:'get',
    });
}









// WEBPACK FOOTER //
// ./src/apis/magazine.api.js